import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo_blanco.png";

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <Link onClick={ClickHandler} to="/">
                    <img src={Logo} width={150} alt="blog" />
                  </Link>
                </div>
                <ul>
                  <li>
                    <a
                      href="https://www.youtube.com/@JANSCONSULTING"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://web.facebook.com/JANS.Consulting"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/jansconsulting/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contacto</h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    <li>
                      <i className="fi flaticon-location"></i>CR 12 24 45 Cajica
                      Cundinamarca
                    </li>
                    <li>
                      <i className="fi flaticon-phone-call"></i>+57 333 646 3507
                    </li>
                    <li>
                      <i className="fi flaticon-send"></i>
                      contacto@jansconsulting.com.co
                    </li>
                    <li>
                      <i className="fi flaticon-send"></i>{" "}
                      <Link className="text-white" to="/politica-privacidad">
                        Politica de Privacidad y Datos
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                        <div className="widget link-widget">
                            <div className="widget-title">
                                <h3>Services </h3>
                            </div>
                            <ul>
                                <li><Link onClick={ClickHandler} to="/service-single">Advanced Analytics</Link></li>
                                <li><Link onClick={ClickHandler} to="/service-single">Corporate Finance</Link></li>
                                <li><Link onClick={ClickHandler} to="/service-single">Information Technology</Link></li>
                                <li><Link onClick={ClickHandler} to="/service-single">Customer Strategy</Link></li>
                                <li><Link onClick={ClickHandler} to="/service-single">Change Management</Link></li>
                            </ul>
                        </div>
                    </div> */}

            {/* <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
                        <div className="widget instagram">
                            <div className="widget-title">
                                <h3>Projects</h3>
                            </div>
                            <ul className="d-flex">
                                <li><Link onClick={ClickHandler} to="/project-single"><img src={ins1} alt=""/></Link></li>
                                <li><Link onClick={ClickHandler} to="/project-single"><img src={ins2} alt=""/></Link></li>
                                <li><Link onClick={ClickHandler} to="/project-single"><img src={ins3} alt=""/></Link></li>
                                <li><Link onClick={ClickHandler} to="/project-single"><img src={ins4} alt=""/></Link></li>
                                <li><Link onClick={ClickHandler} to="/project-single"><img src={ins5} alt=""/></Link></li>
                                <li><Link onClick={ClickHandler} to="/project-single"><img src={ins6} alt=""/></Link></li>
                            </ul>
                        </div>
                    </div> */}
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy; 2025 JansProgramming by{" "}
                <Link onClick={ClickHandler} to="/home">
                  acamposdigital.com
                </Link>
                . Derechos Reservados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
